import { render, staticRenderFns } from "./system-role.vue?vue&type=template&id=e9436280&scoped=true"
import script from "./system-role.vue?vue&type=script&lang=js"
export * from "./system-role.vue?vue&type=script&lang=js"
import style0 from "./system-role.vue?vue&type=style&index=0&id=e9436280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9436280",
  null
  
)

export default component.exports